import React, {Component} from 'react';

class Loader extends Component {

    constructor(props) {
        super(props);
        this.state = {
            // menu:[],
        }
    }

    render() {
        return (
            <div className="ps-page-placeholder" aria-label="Loading content">
                <div className="ps-page-placeholder__header">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div className="ps-page-placeholder__hero"></div>
                <div className="ps-page-placeholder__grid">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        );
    }
}

export default Loader;
